<template>
  <section class="history-search" v-if="value==''">
    <header class="his-header">
      <p>
        <span>历史搜索</span>
        <span>
          <i @click="clear"></i>
        </span>
      </p>
    </header>
    <div class="list">
      <span class="item" v-for="(item, index) in list" :key="index" @click="onItemClick(item)">
        <span>{{ item }}</span>
        <img class="remove" src="@/assets/images/close@2x.png" @click.stop="deleteHis(item)" />
      </span>
    </div>
  </section>
</template>
<script>
export default {
  name: "SearchHistory",
  props: {
    type: {
      type: String,
      default: "course"
    },
    value: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      list: this.$storage().get("search-" + this.type) || []
    };
  },
  computed: {
    user() {
      return this.$store.state.personInfo;
    }
  },
  watch: {
    user() {
      this.list = this.$storage().get("search-" + this.type) || [];
    }
  },
  methods: {
    persist() {
      this.$storage().set("search-" + this.type, this.list);
    },
    add(new_his) {
      let index = this.list.indexOf(new_his);
      if (index != -1) {
        this.list.splice(index, 1);
      }
      this.list.unshift(new_his);
      if (this.list.length > 5) {
        this.list.pop();
      }
      this.persist();
    },
    clear() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除历史记录吗？"
        })
        .then(() => {
          this.list = [];
          this.persist();
        })
        .catch(() => {});
    },
    deleteHis(his) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除历史记录吗？"
        })
        .then(() => {
          let index = this.list.indexOf(his);
          if (index != -1) {
            this.list.splice(index, 1);
          }
          this.persist();
        })
        .catch(() => {});
    },
    onItemClick(item) {
      this.$emit("change", item);
    }
  }
};
</script>
<style lang="scss" scoped>
.history-search {
  margin: 30px 34px;
  .his-header {
    height: 80px;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      span {
        &:nth-child(1) {
          font-size: 30px;
          color: #333;
          font-weight: bold;
        }
        &:nth-child(2) {
          i {
            display: inline-block;
            background: url("../assets/images/delete-history.png") no-repeat;
            background-size: 100% 100%;
            width: 28px;
            height: 28px;
          }
        }
      }
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    .item {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      margin: 30px 20px 0 0;
      padding: 0 32px;
      border-radius: 34px;
      background: rgba(247, 247, 247, 1);
      font-size: 24px;
      color: #333;
      position: relative;
    }
    .remove {
      width: 28px;
      height: 28px;
      position: absolute;
      right: -6px;
      top: -2px;
    }
  }
}
</style>